<div class="appContainer">
  <router-outlet></router-outlet>
</div>

